import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { GridOptions } from "ag-grid/main";
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SharedService } from '../shared/shared.service';
import { ReportsService } from './reports.service';
import { AgencyList } from '../shared/agency.model';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ReportsComponent implements OnInit {
	public agencyList : Array <AgencyList>;
	public gridOptions: GridOptions;
  public sub: any;
  public reportType: string;  
  public reportMenu : string;
  public reportsError: string;
  public reportsData; Object;
	colorTheme = 'theme-dark-blue';
	bsConfig: Partial<BsDatepickerConfig>;
	reportsForm: FormGroup;
  minDate: Date;
  maxDate: Date;

  constructor(
  	private formBuilder: FormBuilder,
  	private sharedService : SharedService,
    private reportsService : ReportsService,
    private route: ActivatedRoute,
  ) {
    this.minDate = new Date();
    this.maxDate = new Date();
    this.minDate.setFullYear(this.minDate.getFullYear() - 2);
    //this.sharedService.currentPageName = "Reports";
    this.sharedService.publishCurrentPage('Reports');
    this.sharedService.showAgencyInformation = true;
  }

	ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.sharedService.getAgencyList('combo')
      .subscribe((response) => {
        this.agencyList = response;
        this.reportsForm.patchValue({
          iataNumber: this.agencyList[0].iatacode
        })
      });
      this.reportType = params['reportType'];
      this.resetReport();
      this.sharedService.getReportsMenu().subscribe((response) => {
        for(let i=0; i<response.result.length; i++) {
          if(response.result[i].id === this.reportType) {
            this.reportMenu = response.result[i].menu;
          }
        }
      });
      if(this.reportsForm)
        this.reportsForm.reset();
    });
    this.buildFormValidations();
    this.bsConfig = Object.assign({}, {containerClass: this.colorTheme});      
  }

  buildFormValidations() {
    this.reportsForm = this.formBuilder.group({
      iataNumber: ['', Validators.required ],
      startDate: ['', Validators.required ],
      endDate: ['', Validators.required ],
    });
  }
	//On form submit for fetching reports
	fetchReports(formDetails: any):void {
    this.resetReport();
    this.reportsService.getReports(formDetails, this.reportType).subscribe((response) => {
      this.reportsData = response;
      this.gridOptions.columnDefs = response.columnDefs;
    	this.gridOptions.rowData = response[this.reportsService.reportsData[this.reportType]['node']];
      if(this.gridOptions.api) {
        this.gridOptions.api.setColumnDefs(this.gridOptions.columnDefs);
        this.gridOptions.api.setRowData(this.gridOptions.rowData);
      }
    },
    (error) => {
      console.log(error);
      this.reportsError = JSON.parse(error.Error).message;
    });
  }

  resetReport() {
    this.gridOptions = <GridOptions>{};
    this.reportsError = '';
    this.gridOptions = {
      paginationAutoPageSize:true,
      pagination: true,
      suppressColumnVirtualisation: true,
      enableColResize: true
    }
  }

  ngOnDestroy() {
    if(this.sub)
      this.sub.unsubscribe();
  }
}


// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/reports/reports.component.ts